import { ApproveBadgesCtrl } from "./controllers/approve";
import { BadgeCtrl } from "./controllers/badge";
import { BadgesCtrl } from "./controllers/badges";
import { AwardBadgeCtrl } from "./controllers/award";
import { BadgeFormCtrl } from "./controllers/form";
import { BadgeTemplatesCtrl } from "./controllers/templates";
import { BadgeService } from "./services/badges";
import { UserBadgesDetailsComponent } from "./components/user-badges-details/user-badges-details.component";
import { BadgesModalsService } from "./services/badgesModals";

const mod = angular.module("badges", []);
mod.controller("ApproveBadgesCtrl", ApproveBadgesCtrl);
mod.controller("BadgeCtrl", BadgeCtrl);
mod.controller("BadgesCtrl", BadgesCtrl);
mod.controller("AwardBadgeCtrl", AwardBadgeCtrl);
mod.controller("BadgeFormCtrl", BadgeFormCtrl);
mod.controller("BadgeTemplatesCtrl", BadgeTemplatesCtrl);
mod.service("BadgeService", BadgeService);
mod.service("BadgesModalsService", BadgesModalsService);
mod.component("userBadgesDetails", UserBadgesDetailsComponent);

export default mod.name;
